import { types } from "../action-types";

const initialState = {
    loading: false,
    success: false,
    error: false,
    response: []
};

const updateGigReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_GIG_REQUESTED:
            return {
                ...state,
                loading: true,
                success: false
            };

        case types.UPDATE_GIG_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                error: false,
                response: action.payload
            };
        case types.UPDATE_GIG_FAILURE:
            return {
                ...state,
                loading: false,
                success: false,
                error: true,
            };
        default:
            return state;
    }
};
export default updateGigReducer;
